import React from 'react';
import {
  useNavigate,
} from 'react-router-dom';
import {
  toast,
} from 'react-toastify';

import {
  useDispatch,
} from 'react-redux';

import {
  coreActions,
} from '@gymcloud/core';

import {
  NewAnnouncement,
} from 'web-components';

const NewAnnouncementPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <NewAnnouncement
      onRequestSubmit={(body, actions) => {
        dispatch(
          coreActions.requestCreateAnnouncement({
            body,
            callbacks: {
              ...actions,
              onSuccess: () => {
                toast.success(
                  'Announcement sent successfully',
                );
                navigate('/welcome');
              },
            },
          }),
        );
      }}
    />
  );
};

export default NewAnnouncementPage;
